import { Spotlight as AkSpotlight } from '@atlaskit/onboarding';

import { wrapComponentForChoreographer } from '../utils';

type AkSpotlightProps = Parameters<typeof AkSpotlight>[0];

export const Spotlight = wrapComponentForChoreographer<AkSpotlightProps>(AkSpotlight);
